import { withInstall } from '@ll-plus/utils'

import Tag from './src/tag.vue'

export const LlTag = withInstall(Tag)
export default LlTag
export * from './src/tag'

declare module 'vue' {
  export interface GlobalComponents {
    LlTag: typeof Tag
  }
}
